import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { getStoredAuthToken } from '../auth/auth-token';
import { UserProfileService } from '../services/users/userDetails.service';

export const adminAuthGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const profileService = inject(UserProfileService);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  return profileService.getUserProfile().pipe(
    map((user: any) => {
      if (user && (user.is_admin || user.is_super_admin)) {
        return true;
      }
      return router.createUrlTree(['/home']);
    }),
    catchError(() => {
      return of(
        router.createUrlTree(['/admin/login'], {
          queryParams: { redirect: state.url },
        })
      );
    })
  );
};
